export default __webpack_public_path__ + "static/media/flag-al.9536cc47.svg";